<template>
    <div>
        <div>
            <SignInPC v-if="isPC" />
            <SignInH5 v-else />
        </div>
    </div>
</template>
<script>
    import SignInH5 from '../components/SignInH5';
    import SignInPC from '../components/SignInPC';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
    };
</script>